module.exports = __webpack_public_path__ + "static/tech-35c19ad75f04b0e4de503c5ee282bc29.png";